import ApiService from './api.service'

const ClubService = {
  index (search = '', page = 1) {
    return ApiService.get(`api/v1/admin/clubs?search=${search}&page=${page}`)
  },

  show (uuid) {
    return ApiService.get('api/v1/admin/clubs/' + uuid)
  },

  update (uuid, data) {
    return ApiService.put('api/v1/admin/clubs/' + uuid, data)
  },

  store (data) {
    return ApiService.post('api/v1/admin/clubs', data)
  },

  merge (data) {
    return ApiService.postWithoutLoading('api/v1/admin/clubs/merge', data)
  },

  suggestShortName (name) {
    return ApiService.get('api/v1/admin/clubs/suggest-short-name', { params: { name } })
  }
}

export default ClubService
